//React
import * as React from "react";

//React Router
import { Redirect } from "react-router-dom";

//Components
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

// Framework
import { getURLByEnv } from "../../framework/utils/URL";

//Managers
import { NetworkManager } from "./../../managers/NetworkManager";
import { StyleManager } from "../../managers/StyleManager";

const styles = StyleManager.getStyles().LogoutView;

interface LogoutState {
    redirectToLogin: boolean;
}

/**
 * @description Contain the Logout View
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Logout
 * @extends {React.Component}
 */
export default class Logout extends React.Component<{}, LogoutState> {

    /**
     * Creates an instance of Logout.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Logout
     */
    constructor(props: any) {
        super(props);
        this.state = {
            redirectToLogin: false
        };
    }

    /**
     * @description Render the Logout View
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns Logout View
     * @memberof Logout
     */
    render() {
        if (this.state.redirectToLogin) {
            return <Redirect to={`${getURLByEnv()}/`} />;
        } else {
            NetworkManager.disconnect();
            return (
                <div style={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100% - 56px)",
                    justifyContent: "center"
                }}>
                    <Typography type="body1" gutterBottom align="center" style={styles.text}>
                        Vous avez été déconnecté avec succès.
                    </Typography>
                    <Button
                        raised
                        style={styles.loginButton}
                        onClick={() => {
                            this.setState({
                                redirectToLogin: true
                            });
                        }}>
                        Se reconnecter
                    </Button>
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/UI/views/Logout.tsx